import { ACTION_TYPES } from './action_types';
import { DataAction } from '@sonar-software/xuder';

import { UpdatePeriscopeInfoSync, UpdatePeriscopeSync } from '@sonar-software/sonar-ts-types';

export type UpdateAnalysisPeriscopeAction = DataAction<ACTION_TYPES.UPDATE_ANALYSIS_PERISCOPE, UpdatePeriscopeSync>;
export type UpdatePeriscopeAction = DataAction<ACTION_TYPES.UPDATE_PERISCOPE, UpdatePeriscopeSync>;
export type UpdatePeriscopeInfoAction = DataAction<ACTION_TYPES.UPDATE_PERISCOPE_INFO, UpdatePeriscopeInfoSync>;

export function updateAnalysisPeriscope(request: UpdatePeriscopeSync): UpdateAnalysisPeriscopeAction {
	return {
		data: request,
		type: ACTION_TYPES.UPDATE_ANALYSIS_PERISCOPE
	};
}

export function updatePeriscope(request: UpdatePeriscopeSync): UpdatePeriscopeAction {
	return {
		data: request,
		type: ACTION_TYPES.UPDATE_PERISCOPE
	};
}

export function updatePeriscopeInfo(request: UpdatePeriscopeInfoSync): UpdatePeriscopeInfoAction {
	return {
		data: request,
		type: ACTION_TYPES.UPDATE_PERISCOPE_INFO
	};
}
